import { render, staticRenderFns } from "./Hero.vue?vue&type=template&id=f52cb7ec&scoped=true&"
import script from "./Hero.vue?vue&type=script&lang=ts&"
export * from "./Hero.vue?vue&type=script&lang=ts&"
import style0 from "./Hero.vue?vue&type=style&index=0&id=f52cb7ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52cb7ec",
  null
  
)

export default component.exports